import { shouldShowPayAtPropertyPill } from '../utils'

interface PayAtPropertyChoiceParams {
  isPropertyCollectEnabled: boolean
  hasFlight: boolean
  relatedPayAtPropertyRate?: App.BedbankRate
}

interface PayAtPropertyVisibilityParams {
  isPropertyCollectEnabled: boolean
  flightsBookingActive: boolean
  rate: App.BedbankRate
  relatedPayAtPropertyRate?: App.BedbankRate
}

export function shouldOfferBedbankPayAtPropertyChoice({
  isPropertyCollectEnabled,
  hasFlight,
  relatedPayAtPropertyRate,
}: PayAtPropertyChoiceParams): boolean {
  return isPropertyCollectEnabled && !hasFlight && !!relatedPayAtPropertyRate
}

export function getBedbankPayAtPropertyVisibility({
  isPropertyCollectEnabled,
  flightsBookingActive,
  rate,
  relatedPayAtPropertyRate,
}: PayAtPropertyVisibilityParams) {
  return {
    canPayAtProperty: isPropertyCollectEnabled && !flightsBookingActive && shouldShowPayAtPropertyPill(rate),
    hasRelatedPayAtPropertyRate: isPropertyCollectEnabled && !!relatedPayAtPropertyRate,
  }
}
